<template>
  <div class="main">
    <report-top></report-top>

    <div id="formTable">
      <div class="formTableItem">
        <p class="label">单位筛选</p>
        <selectAlotGroup
          placement="left"
          @groupIdList="
            searchItem.groupIdList = $event;
            getList();
          "
        ></selectAlotGroup>
      </div>
      <div id="ddas">
        <Button @click="search" type="error" class="chaxun">查询</Button>
        <Button @click="exportAll" icon="md-download">导出</Button>
        <Button @click="openAdd" type="primary" size="small" icon="md-add"
          >新增</Button
        >

        <Button @click="impBtn" class="chaxun">导入</Button>
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="frontImageUrl">
        <viewer v-if="row.pic">
          <img
            :src="axios.platConfig.fileUri + row.pic.split(',')[0]"
            width="24"
            height="24"
            style="margin-right: 4px; cursor: pointer"
          />
        </viewer>
      </template>
      <template slot-scope="{ row, index }" slot="backImageUrl">
        <viewer v-if="row.pic">
          <img
            :src="axios.platConfig.fileUri + row.pic.split(',')[1]"
            width="24"
            height="24"
            style="margin-right: 4px; cursor: pointer"
          />
        </viewer>
      </template>
      <template slot-scope="{ row, index }" slot="urgentFrontPicUrl">
        <viewer v-if="row.urgentFrontPic">
          <img
            :src="axios.platConfig.fileUri + row.urgentFrontPic"
            width="24"
            height="24"
            style="margin-right: 4px; cursor: pointer"
          />
        </viewer>
      </template>
      <template slot-scope="{ row, index }" slot="urgentBackPicUrl">
         <viewer v-if="row.urgentBackPic">
          <img
            :src="axios.platConfig.fileUri + row.urgentBackPic"
            width="24"
            height="24"
            style="margin-right: 4px; cursor: pointer"
          />
        </viewer>
      </template>


      <template slot-scope="{ row, index }" slot="driverLicenseUrl">
        <viewer v-if="row.licensePic">
          <img
            :src="axios.platConfig.fileUri + row.licensePic"
            width="24"
            height="24"
            style="margin-right: 4px; cursor: pointer"
          />
        </viewer>
      </template>
      <!-- <template slot-scope="{ row, index }" slot="vehicleLicenseUrl">
        <viewer v-if="row.licensePic">
          <img
            :src="axios.platConfig.fileUri + row.licensePic.split(',')[1]"
            width="24"
            height="24"
            style="margin-right: 4px; cursor: pointer"
          />
        </viewer>
      </template> -->
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <Modal
      v-model="openForm"
      :title="isAdd ? '新增司机' : '编辑司机'"
      footer-hide
      width="900"
      :styles="{height: '660px',overflowY: 'scroll'}"
      @on-cancel="cliclCancelBtn"
    >
      <Form ref="item" :model="item" :rules="ruleValidate" :label-width="90">
        <Row :gutter="16">
          <Col span="8">
            <FormItem label="姓名" prop="name">
              <Input
                v-model="item.name"
                maxlength="18"
                show-word-limit
                placeholder="请输入"
              />
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="所属部门" prop="groupName">
              <selectGroup
                :name="item.groupName"
                @update:name="item.groupName = $event"
                :id="item.groupId"
                @update:id="item.groupId = $event"
              >
              </selectGroup>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="绑定账号" prop="userName">
              <selectUser
                keyword="司机"
                :name="item.userName"
                @update:name="item.userName = $event"
                :id="item.userId"
                @update:id="item.userId = $event"
              >
              </selectUser>
            </FormItem>
          </Col>

          <Col span="8">
            <FormItem label="绑定车辆" prop="carNo">
              <Input
                v-model="item.carNo"
                @on-focus="openCar = true"
                placeholder="选择车辆"
              ></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="电话" prop="tel">
              <Input
                v-model="item.tel"
                maxlength="11"
                show-word-limit
                type="number"
                placeholder="请输入"
              />
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="其他联系方式" prop="contact">
              <Input
                v-model="item.contact"
                maxlength="18"
                show-word-limit
                placeholder="请输入"
              />
            </FormItem>
          </Col>
            <Col span="8">
            <FormItem label="紧急联系人姓名" prop="urgentName">
              <Input
                v-model="item.urgentName"
                maxlength="18"
                show-word-limit
                placeholder="请输入"
              />
            </FormItem>
          </Col>
            <Col span="8">
            <FormItem label="紧急联系人电话"  prop="urgentContact">
              <Input
                v-model="item.urgentContact"
                maxlength="11"
                show-word-limit
                placeholder="请输入"
              />
            </FormItem>
          </Col>
           <Col span="8">
            <FormItem label="紧急联系人身份证号" >
              <Input
                v-model="item.urgentIdCard"
                maxlength="18"
                show-word-limit
                placeholder="请输入"
              />
            </FormItem>
          </Col>
           <Col span="8">
            <FormItem label="紧急联系人身份证正面照片" >
              <ly-photo
                ref="urgentFrontPicUrlRef"
                :one="true"
                v-model="item.urgentFrontPic"
              ></ly-photo>
            </FormItem>
          </Col>
           <Col span="8">
            <FormItem label="紧急联系人身份证反面照片" >
              <ly-photo
                ref="urgentBackPicUrlRef"
                :one="true"
                v-model="item.urgentBackPic"
              ></ly-photo>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="身份证号" prop="idCard">
              <Input
                v-model="item.idCard"
                maxlength="18"
                show-word-limit
                placeholder="请输入"
              />
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="身份证正面照片" >
              <ly-photo
                ref="frontImageUrlRef"
                :one="true"
                v-model="item.frontImageUrl"
              ></ly-photo>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="身份证反面照片" >
              <ly-photo
                ref="backImageUrlRef"
                :one="true"
                v-model="item.backImageUrl"
              ></ly-photo>
            </FormItem>
          </Col>

          <Col span="8">
            <FormItem label="性别" prop="sex">
              <Select v-model="item.sex">
                <Option
                  v-for="(x, index) in $t('sex')"
                  :value="index"
                  :key="index"
                  >{{ x }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="年龄" prop="age">
              <InputNumber
                :min="0"
                :max="99"
                v-model="item.age"
                style="width: 100%"
              ></InputNumber>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="职位" prop="job">
              <Input v-model="item.job" placeholder="请输入" />
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="住址" prop="address">
              <Input v-model="item.address" placeholder="请输入" />
            </FormItem>
          </Col>

          <Col span="8">
            <FormItem label="从业资格证号" prop="dqcNo">
              <Input
                maxlength="18"
                show-word-limit
                v-model="item.dqcNo"
              ></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="服务期限" prop="serverTerm">
              <Input v-model="item.serverTerm"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="驾驶证号" prop="licenseNo">
              <Input
                maxlength="18"
                show-word-limit
                v-model="item.licenseNo"
              ></Input>
            </FormItem>
          </Col>
          <!-- <Col span="8">
            <FormItem label="行驶证号" prop="vehicleLicense">
              <Input
                maxlength="18"
                show-word-limit
                v-model="item.vehicleLicense"
              ></Input>
            </FormItem>
          </Col> -->
          <Col span="8">
            <FormItem label="驾驶证照片" prop="licensePic">
              <ly-photo
                ref="driverLicenseUrlRef"
                :one="true"
                v-model="item.licensePic"
              ></ly-photo>
            </FormItem>
          </Col>
          <!-- <Col span="8">
            <FormItem label="行驶证照片" prop="vehicleLicenseUrl">
              <ly-photo
                ref="vehicleLicenseUrlRef"
                :one="true"
                v-model="item.vehicleLicenseUrl"
              ></ly-photo>
            </FormItem>
          </Col> -->

          <Col span="8">
            <FormItem label="入职日期" prop="licenseNo">
              <DatePicker
                type="date"
                placeholder="请选择"
                v-model="item.entryDate1"
              ></DatePicker>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="驾驶证到期日期" prop="licenseValidTime1">
              <DatePicker
                type="date"
                placeholder="请选择"
                v-model="item.licenseValidTime1"
              ></DatePicker>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="驾驶证年审日期" prop="licenseArTime1">
              <DatePicker
                type="date"
                placeholder="请选择"
                v-model="item.licenseArTime1"
              ></DatePicker>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="状态" prop="signState">
              <Select v-model="item.signState">
                <Option
                  v-for="(x, index) in $t('signState')"
                  :value="index"
                  :key="index"
                  >{{ x }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="备注" prop="remark">
              <Input
                type="textarea"
                v-model="item.remark"
                placeholder="请输入"
              ></Input>
            </FormItem>
          </Col>

          <!-- <Col span="16">
            <FormItem label="附件上传" prop="idCard">
              <IdCardUpload ref="idCardUpload" />
              <DriverLicenseUpload

              />
            </FormItem>
          </Col> -->
        </Row>
        <Row type="flex" justify="end">
          <Col span="24">
            <div class="btn-wrap">
              <Button @click="resetForm">重置表单</Button>
              <Button type="primary" @click="addUpdate('item')"
                >提交表单</Button
              >
            </div>
          </Col>
        </Row>
      </Form>
    </Modal>
    <Drawer
      title="请选择车辆"
      placement="left"
      :closable="true"
      v-model="openCar"
      draggable
      class="my-drawer"
      width="450"
    >
      <carTool @car="reCar"></carTool>
    </Drawer>
    <fujian ref="fujian"></fujian>
    <daoRuWl ref="daoRuWl" @finesh="getList"></daoRuWl>
  </div>
</template>
<script>
import axios from "axios";
import fujian from "./fujian.vue";
import daoRuWl from "../xiyang/common/daoRuWl.vue";
// import IdCardUpload from "../common/customComponent/IdCardUpload.vue";
// import DriverLicenseUpload from "../common/customComponent/DriverLicenseUpload.vue";
export default {
  components: { daoRuWl, fujian, },
  data() {
    return {
      openCar: false,
      openForm: false,
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },

        {
          title: "姓名",
          key: "name",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "账号",
          key: "userAccount",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "绑定车辆",
          key: "carNo",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "所属单位",
          key: "groupName",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "入职日期",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.entryDate, "yymmdd"));
          },
          minWidth: 100,
          maxWidth: 200,
        },

        {
          title: "驾驶证号",
          key: "licenseNo",
          minWidth: 150,
          maxWidth: 200,
        },
        {
          title: "驾驶证到期日期",
          render: (h, data) => {
            return h(
              "div",
              this.utils.time(data.row.licenseValidTime, "yymmdd")
            );
          },
          minWidth: 100,
          maxWidth: 200,
        },

        {
          title: "驾驶证年审日期",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.licenseArTime, "yymmdd"));
          },
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: " 驾驶证",
          key: "licensePic",
          slot: "driverLicenseUrl",
          minWidth: 90,
        },
        // {
        //   title: "行驶证号",
        //   key: "vehicleLicense",
        //   minWidth: 150,
        //   maxWidth: 200,
        // },
        // {
        //   title: "行驶证到期日期",
        //   render: (h, { row }) => {
        //     return h(
        //       "div",
        //       this.utils.time(row.vehicleLicenseValidTime, "yymmdd")
        //     );
        //   },
        //   minWidth: 100,
        //   maxWidth: 200,
        // },
        {
          title: "身份证号",
          key: "idCard",
          minWidth: 150,
          maxWidth: 200,
        },
        {
          title: "身份证正面照",
          key: "pic",
          slot: "frontImageUrl",
          minWidth: 90,
        },
        {
          title: " 身份证反面照",
          key: "pic",
          slot: "backImageUrl",
          minWidth: 90,
        },
          {
          title: "紧急联系人姓名",
          key: "urgentName",
          minWidth: 150,
          maxWidth: 200,
        },
          {
          title: "紧急联系人电话",
          key: "urgentContact",
          minWidth: 150,
          maxWidth: 200,
        },
         {
          title: "紧急联系人身份证号",
          key: "urgentIdCard",
          minWidth: 150,
          maxWidth: 200,
        },
        {
          title: "紧急联系人身份证正面",
          key: "urgentFrontPic",
          slot: "urgentFrontPicUrl",
          minWidth: 90,
        },
        {
          title: "紧急联系人身份证反面",
          key: "urgentBackPic",
          slot: "urgentBackPicUrl",
          minWidth: 90,
        },

        // {
        //   title: " 行驶证",
        //   key: "licensePic",
        //   slot: "vehicleLicenseUrl",
        //   minWidth: 90,
        // },

        {
          title: "从业资格证号",
          key: "dqcNo",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "电话",
          key: "tel",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "其他联系方式",
          key: "contact",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "职位",
          key: "job",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "年龄",
          key: "age",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "服务期限",
          key: "serverTerm",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "性别",
          key: "sex",
          minWidth: 100,
          maxWidth: 200,
          render: (h, data) => {
            return h("div", this.$t("sex." + data.row.sex));
          },
        },
        {
          title: "状态",
          key: "sex",
          minWidth: 100,
          maxWidth: 200,
          render: (h, data) => {
            return h("div", this.$t("signState." + data.row.signState));
          },
        },
        {
          title: "创建者账号",
          key: "createAccount",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "创建时间",
          key: "createTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "操作",
          slot: "action",
          width: 180,
          align: "center",
          fixed: "right",
        },
      ],

      tableData: [],
      item: {
        groupId: "",
        groupName: "",
        userId: "",
        carId: "",
        carNo: "",
        dqcNo: "", //从业资格证号
        entryDate: "", //入职日期
        entryDate1: new Date(), //入职日期
        licenseArTime: "", //驾驶证年审日期
        licenseArTime1: new Date(), //驾驶证年审日期
        licenseNo: "", //驾驶证号
        licenseValidTime: "", //驾驶证到期
        licenseValidTime1: new Date(), //驾驶证到期
        serverTerm: "", //服务期限
        sex: "0",
        signState: "1", //0--解约 1--签约

        frontImageUrl: "", //身份证正面
        backImageUrl: "", //身份证反面
        driverLicenseUrl: "", //驾驶证
        // vehicleLicenseUrl: "", //行驶证
        pic: "", //身份证正面 + 身份证反面
        licensePic: "", //驾驶证
        vehicleLicense: "", // 行驶证号
        vehicleLicenseValidTime: null, //行驶证到期
        urgentName:"", //紧急联系人姓名
        urgentContact:"", //紧急联系人电话
        urgentIdCard:"", //紧急联系人身份证号
        urgentFrontPic :"", //紧急联系人身份证正面
        urgentBackPic :"", //紧急联系人身份证反面
      },
      ruleValidate: {
        driverNo: { required: true, message: "必填" },
        name: { required: true, message: "必填" },
        groupName: { required: true, message: "必填" },
        model: { required: true, message: "必填" },
        frontImageUrl: { required: true, message: "必填" },
        backImageUrl: { required: true, message: "必填" },
        licensePic: { required: true, message: "必填" },
        vehicleLicense: { required: true, message: "必填" },
        vehicleLicenseValidTime: { required: true, message: "必填" },
        urgentName: { required: true, message: "必填" },
        urgentContact: { required: true, message: "必填" },
        urgentIdCard: { required: true, message: "必填" },
        urgentFrontPic: { required: true, message: "必填" },
        urgentBackPic: { required: true, message: "必填" },
        idCard: { required: true, message: "必填" },
        licenseNo: { required: true, message: "必填" },
        licenseValidTime1: { required: true, message: "必填" },
      },
      searchItem: {
        keyword: "",
        pageSize: 50,
        pageNumber: 1,
        groupIdList: [],
      },
      total: 0,
      imp: {
        temUrl: this.axios.ipPort + "/cloud-common-server-dm/driver3/tmpl",
        url: this.axios.ipPort + "/cloud-common-server-dm/driver3/imp",
      },
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.dm + "/driver/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (const i in data) {
          data[i].entryDate1 = this.utils.sjcTo(data[i].entryDate);
          data[i].licenseArTime1 = this.utils.sjcTo(data[i].licenseArTime);
          data[i].licenseValidTime1 = this.utils.sjcTo(
            data[i].licenseValidTime
          );
          data[i].signState = String(data[i].signState);
          data[i].sex = String(data[i].sex);
        }
        this.tableData = data;
        console.log(data);
      });
    },
    exportAll() {
      var params = [
        {
          name: "keyword",
          value: this.searchItem.keyword,
        },
        {
          name: "groupIdList",
          value: this.searchItem.groupIdList,
        },
      ];
      this.utils.exportData(axios.dm + "/driver/export", params);
    },
    impBtn() {
      this.$refs.daoRuWl.openWin(this.imp);
    },
    addUpdate(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.item.entryDate = this.utils.toSjc(this.item.entryDate1);
          this.item.licenseArTime = this.utils.toSjc(this.item.licenseArTime1);
          this.item.licenseValidTime = this.utils.toSjc(
            this.item.licenseValidTime1
          );
          this.item.pic =
            this.item.frontImageUrl + "," + this.item.backImageUrl;
          // this.item.licensePic =
          //   this.item.driverLicenseUrl + "," + this.item.vehicleLicenseUrl;
          if (this.isAdd) {
            axios({
              method: "post",
              url: axios.dm + "/driver/add",
              data: this.item,
            }).then((res) => {
              console.log(res);
              if (res) {
                this.openForm = false;
                this.getList();
              }
            });
          } else {
            axios({
              method: "post",
              url: axios.dm + "/driver/update",
              data: this.item,
            }).then((res) => {
              if (res) {
                this.openForm = false;
                this.getList();
              }
            });
          }
        }
      });
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          axios({
            method: "post",
            url: axios.dm + "/driver/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.openForm = true;
      this.isAdd = false;
      this.item = {...row};
      this.item.userName=row.userAccount;

      const picArray = row.pic.split(",");
      // const licensePicArray = row.licensePic.split(",");
      this.item.frontImageUrl = picArray[0];
      this.item.backImageUrl = picArray[1];

      // this.item.driverLicenseUrl = licensePicArray[0];
      // this.item.vehicleLicenseUrl = licensePicArray[1];
    },
    openAdd() {
      this.openForm = true;
      this.isAdd = true;
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },
    cliclCancelBtn() {
      this.openForm = false;
      var arr = this.tableData;
      this.tableData = [];
      setTimeout(() => {
        this.tableData = arr;
      }, 200);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    reCar(v) {
      this.openCar = false;
      this.item.carId = v.id;
      this.item.carNo = v.carNo;
    },
    search() {
      this.getList();
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/information/driver.vue